import { Inject, Injectable, forwardRef } from '@kaokei/use-vue-service';
import { RouterService } from '~/services/router.service';
import { StorageService } from '~/services/storage.service';
import { ZONE_VALUES } from '~/utils/constant';
import { isProd } from '~/utils/environment';

@Injectable()
export class ZoneService {
  public zone = 'cpp';

  @Inject(forwardRef(() => StorageService))
  public storageService!: StorageService;

  @Inject(forwardRef(() => RouterService))
  public routerService!: RouterService;

  public getSiteUrl() {
    return `${location.origin}/${this.zone}`;
  }
  public getWechatRedirectUrl() {
    if (isProd()) {
      return `https://htoj.com.cn/${this.zone}`;
    } else {
      return `https://testing.htoj.com.cn/${this.zone}`;
    }
  }

  /**
   * 初始化zone
   */
  public initZone(zone: string) {
    const valid = ZONE_VALUES.includes(zone);
    if (valid) {
      this.zone = zone;
      if (window.BASE_URL === zone) {
        // 用户访问的URL自带的zone和最终计算出的zone一致
        // 并且是一个合法的zone
        // 并且本地没有zone则更新本地zone
        this.updateZoneIfLocalEmpty(zone);
      }
    } else {
      this.routerService.reloadHome();
    }
  }

  /**
   * 更新本地的zone
   */
  public updateZone(zone: string) {
    this.zone = zone;
    this.storageService.setZone(zone);
    this.routerService.updateZone(zone);
  }

  /**
   * 一般情况下用户访问的域和本地域不一致时是不会强制覆盖本地域的
   * 但是特殊情况下是需要强制覆盖本地域的，比如从客户端直接跳转到OJ
   */
  public updateZoneOnly(zone?: string) {
    this.zone = zone || this.zone;
    this.storageService.setZone(this.zone);
  }

  /**
   * 如果本地zone为空，更新本地zone
   */
  public updateZoneIfLocalEmpty(zone: string) {
    const localZone = this.storageService.getZone();
    if (!localZone) {
      this.zone = zone;
      this.storageService.setZone(zone);
      this.storageService.setZoneGuideNeedShow();
    }
  }

  /**
   * 通过弹窗来选择默认的zone
   * 选择完毕后更新本地zone并且设置zone引导
   */
  public updateZoneFromModal() {
    this.storageService.setZoneGuideNeedShow();
    this.updateZone(this.zone);
  }

  public removeZoneGuide() {
    this.storageService.removeZoneGuide();
  }

  public needShowZoneGuide() {
    const localZone = this.storageService.getZone();
    if (localZone) {
      // 本地有zone的前提下判断是否需要展示zone引导
      return this.storageService.isZoneGuideNeedShow();
    }
  }

  public needShowZoneModal() {
    const localZone = this.storageService.getZone();
    if (!localZone) {
      // 本地没有zone的前提下并且用户访问的URL自带的zone和最终计算出的zone不一致
      return window.BASE_URL !== this.zone;
    }
  }
}
